export const StorageIds = {
  ANONYMOUS: 'anonymous',
  REGISTERED: 'registered',
  sessionToken: 'sessionToken',
  sessionId: 'sessionId',
  cacheDuration: 'cacheDuration',
  settings: 'settings',
  featureScreenCounters: 'featureScreenCounters',
  platformUuid: 'platformUuid',
  favoritePageIds: 'favoritePageIds',
  activeRegionId: 'activeRegionId',
  pendingRegionId: 'pendingRegionId',
  privacyRegulation: 'privacyRegulation',
  pendingPrivacyRegulation: 'pendingPrivacyRegulation',
  userSelectedRegionId: 'userSelectedRegionId',
  userEmail: 'userEmail',
  expManifest: 'expManifest',
  expManifestTimestamp: 'expManifestTimestamp',
  expUserTimestamp: 'expUserTimestamp',
  rootDomainEnv: 'rootDomainEnv',
  swCountryCode: 'swCountryCode',
  pendingCountryCode: 'pendingCountryCode',
  ucUserInteraction: 'uc_user_interaction',
  ucSettings: 'uc_settings',
  platform: 'platform',
}

export const StorageLegacyIds = ['disabledSportCategoriesId', 'disabledChannelsId']
